import { useRef } from 'react';
import { noop } from 'lodash';
import { colors, r4 } from '@ardoq/design-tokens';
import styled from 'styled-components';
import { ViewOptionsHeader } from './ViewOptionsHeader';
import { ViewPicker } from './ViewPicker';
import { ViewPaneHeaderProps } from 'appLayout/ardoqStudio/types';
import { connect } from '@ardoq/rxbeach';
import { viewPaneHeader$ } from 'appLayout/ardoqStudio/viewPaneHeader$';
import { PerspectivesAndViewSettings } from './PerspectivesAndViewSettings';
import { useOnClickOutside } from '@ardoq/hooks';
import { t, type I18nLocale } from '@ardoq/i18n';
import type { ViewIds } from '@ardoq/api-types';

const Container = styled.div`
  width: 100%;
  min-height: 100%;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: ${r4};
  background: ${colors.white950};

  user-select: none;
`;

type ViewOptionsProps = ViewPaneHeaderProps & {
  onCloseClick: VoidFunction;
  onViewSelected: (renderedViewId: ViewIds) => void;
  onClickOutside?: VoidFunction;
  i18nLocale: I18nLocale;
};

const ViewOptions = (props: ViewOptionsProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  useOnClickOutside(containerRef, props.onClickOutside ?? noop);

  return (
    <Container ref={containerRef}>
      <ViewOptionsHeader
        onCloseClick={props.onCloseClick}
        closeLabel={t(
          props.i18nLocale,
          'appLayout:closeViewSettings',
          'Close view settings'
        )}
      >
        {t(props.i18nLocale, 'appLayout:viewStyleHeader', 'View style')}
      </ViewOptionsHeader>
      <ViewPicker {...props} />
      <PerspectivesAndViewSettings />
    </Container>
  );
};

const ConnectedViewOptions = connect(ViewOptions, viewPaneHeader$);
export { ConnectedViewOptions };
